import React, { useState, useRef, useEffect } from 'react';

const SingleDropdown = ({ options, selectedOption, onChange, name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const wrapperRef = useRef(null);

  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes(filter.toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      } 
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = option => {
    onChange(option);
    setIsOpen(false);
    setFilter(option); 
  };

  return (
    <div ref={wrapperRef} className="relative">
      <input
        type="text"
        placeholder={name}
        value={filter}
        onClick={() => setIsOpen(!isOpen)}
        onChange={e => setFilter(e.target.value)}
        className="w-full p-2 border-sm rounded-md"
      />
      {isOpen && (
        <ul className="absolute w-full max-h-[200px] overflow-auto z-10 border bg-slate-50">
          {filteredOptions.map(option => (
            <li
              key={option}
              onClick={() => handleSelect(option)}
              className="p-1.5 hover:bg-gray-200 cursor-pointer border-b"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SingleDropdown;
